import Section from "@/app/features/shared/snap-section/Section";
import { Box, Stack } from "@mui/material";
import { ReactNode } from "react";

export function ShowroomContainerFrame({
    children,
    headingId,
    sectionId,
}: Readonly<{
    children: ReactNode;
    headingId?: string;
    sectionId?: string;
}>) {
    return (
        <Section id={sectionId} contentHeight='fit-content' aria-labelledby={headingId}>
            <Stack spacing={4} alignItems='center' className="w-full py-16" >
                {children}
            </Stack>
        </Section>
    )
}

export function ShowroomHeaderFrame({ children, reserveRightRail }: Readonly<{ children: ReactNode; reserveRightRail?: boolean }>) {
    return (
        <Stack
            spacing={2}
            className="w-full text-center"
            sx={{
                boxSizing: 'border-box',
                width: '100%',
                px: '10%',
                ...(reserveRightRail
                    ? {
                        '@media (min-width: 900px)': {
                            width: 'calc(100% - (10vw + 3rem))',
                            mr: 'calc(10vw + 3rem)',
                        },
                    }
                    : {}),
            }}
        >
            {children}
        </Stack>
    )
}

export function ShowroomImageCarouselFrame({ children, reserveRightRail }: Readonly<{ children: ReactNode; reserveRightRail?: boolean }>) {
    return (
        <Box
            sx={{
                boxSizing: 'border-box',
                width: '100%',
                px: '10%',
                ...(reserveRightRail
                    ? {
                        '@media (min-width: 900px)': {
                            width: 'calc(100% - (10vw + 3rem))',
                            mr: 'calc(10vw + 3rem)',
                        },
                    }
                    : {}),
            }}
        >
            {children}
        </Box>
    )
}
